module.exports = __webpack_public_path__ + "img/tip1.00e3d237.png";